module.exports = __webpack_public_path__ + "static/img/header_bg.451d868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/mitu/order/head/header_bg.png
// module id = 9Sxn
// module chunks = 8